<div class="d-flex flex-column align-items-center document-container" id="pdf-print">
  @for (page of documentSections; track page; let i = $index) {
    <div class="preview-page">
      <div class="content-overflow">
        @if (i == 0) {
          @if (headerContent.custom) {
            <div
              [innerHTML]="sanitizer.bypassSecurityTrustHtml(headerContent.content)">
            </div>
          } @else {
            <h5 style="text-align: right; margin-left: 25px;">
              <span>{{headerContent.date}}</span>
            </h5>
            <div class="d-flex">
              @if (headerContent.image?.url) {
                <img class="header-image-preview" [src]="headerContent.image?.url || '//:0'">
              }
              <div>
                <h4 style="text-align: justify; margin-left: 12px;">{{headerContent.name}}</h4>
                <h6 style="text-align: justify; margin-left: 12px;">
                  {{headerContent.data1}}<br>
                  {{headerContent.data2}}
                </h6>
              </div>
            </div>
          }
        }
        @for (section of page; track section) {
          <div
            [innerHTML]="sanitizer.bypassSecurityTrustHtml(section.content)">
          </div>
        }
        @if (i == documentSections.length - 1) {
          <div [className]="'d-flex flex-wrap ' + signatureStyle.align">
            @for (signature of signatures; track signature) {
              <div class="col-4 d-flex flex-column align-items-center">
                <div class="d-flex justify-content-center align-items-center sign-container">
                  @if (signature.image.url) {
                    <img class="sign-image" [src]="signature.image.url || '//:0'">
                  }
                </div>
                <hr class="sign-hr">
                <div class="text-center">{{signature.name}}</div>
                <div class="text-center">{{signature.charge}}</div>
                <div class="text-center">{{signature.date}}</div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
